export default __webpack_public_path__ + "static/media/gallery_03.2c6eb547.jpg";